import React, { useState, useEffect } from 'react';
import Homepage from "./components/homepage";
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';

function App() {
  const [user, setUser] = useState(null);
  const [autoLoggedOut, setAutoLoggedOut] = useState(false);

  // Attempt to load user from localStorage on initial render
  useEffect(() => {
    const userProfile = localStorage.getItem('userProfile');
    if (userProfile) {
      setUser(JSON.parse(userProfile));
    }

    const handleUnauthorized = () => {
      handleLogout();
      setAutoLoggedOut(true);
    };

    window.addEventListener('unauthorized', handleUnauthorized);
    return () => window.removeEventListener('unauthorized', handleUnauthorized);
  }, []);

  const handleLoginSuccess = (credentialResponse) => {
    console.log(credentialResponse);
    const decoded = jwt_decode(credentialResponse.credential);
    console.log(decoded);
    localStorage.setItem('authToken', credentialResponse.credential);
    localStorage.setItem('userProfile', JSON.stringify(decoded));
    setUser(decoded);
    setAutoLoggedOut(false);
  };

  const handleLoginError = () => {
    console.log('Login Failed');
  };

  const handleLogout = () => {
    googleLogout();
    localStorage.removeItem('authToken');
    localStorage.removeItem('userProfile');
    setUser(null);
  };

  return (
    <div>
      {user ? (
        <Homepage onLogout={handleLogout} />
      ) : (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
          <div className="card text-center p-4">
            <h2 className="card-title mb-4">JMPics</h2>
            {autoLoggedOut && (
              <div className="alert alert-warning mb-4" role="alert">
                Your session has expired. You have been logged out automatically.
              </div>
            )}
            <p className="card-text mb-4">Please sign in with your Google account to continue.</p>
            <div className="d-flex justify-content-center">
                <GoogleLogin
                  onSuccess={handleLoginSuccess}
                  onError={handleLoginError}
                />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;